// footer.ts

import {
	animateDisabledButton,
	handleSubmitButton,
	submitNewsletterForm,
} from './footer/newsletterSignUp';
import { toggleAccordions } from './footer/accordionToggling';

/**
 * Various footer setup: newsletter form functions + toggling links accordions
 * depending on screen size.
 */
function setupFooter() {
	handleSubmitButton();
	animateDisabledButton();
	submitNewsletterForm();

	/** Below could be written better, refactor at some point **/
	window.addEventListener('load', function () {
		const footerInner = document.querySelector('#bux-footer');
		if (!footerInner) return;
		const footerInnerWidth = footerInner.clientWidth;
		if (!footerInnerWidth) return;
		toggleAccordions(footerInnerWidth);
	});

	window.addEventListener('resize', function () {
		const footerInner = document.querySelector('#bux-footer');
		if (!footerInner) return;
		const footerInnerWidth = footerInner.clientWidth;
		if (!footerInnerWidth) return;
		toggleAccordions(footerInnerWidth);
	});
}

//
document.addEventListener('DOMContentLoaded', function () {
	setupFooter();
});
